import { createSlice, PayloadAction } from "@reduxjs/toolkit";


export interface batchViewFailedState {
  pageNumber: number;
  search: string;
  pageSize: number;
  loader: boolean;
  isActive: any;
  filter:any;
}

export const initialState: batchViewFailedState = {
  pageNumber: 1,
  search: "",
  pageSize: 25,
  loader: false,
  isActive: "",
  filter: {
    vendorType: [],
    vendorsId: [],
    vendorsCode: [],
    pageSize: 10,
    search: ""
  }
}

const batchViewFailedSlice = createSlice({
  name: "batchUpdateViewFailed",
  initialState,
  reducers: {
    setPageNumberFailed: (state:any, action: PayloadAction<number>) => {
      state.pageNumber = action.payload
    },
    searchAsset: (state:any, action: PayloadAction<string>) => {
      state.pageNumber = 1;
      state.search = action.payload
    },
    setPageSizeFailed: (state:any, action: PayloadAction<number>) => {
      state.pageSize = action.payload;
    },
    setLoader: (state:any, action: PayloadAction<boolean>) => {
      state.loader = action.payload;
    },
  }
})

const { actions, reducer } = batchViewFailedSlice;

export const { setPageNumberFailed, searchAsset, setPageSizeFailed, setLoader } = actions
export default reducer